<script>
export default {
    type: "column2d",
    width: "100%",
    height: "350",
    dataFormat: "json",
    dataSource: {
        chart: {
            // caption: "Countries With Most Oil Reserves [2017-18]",
            // subcaption: "In MMbbl = One Million barrels",
            showvalues: "1",
            xaxisname: "Jenis Kutipan Hasil",
            yaxisname: "Jumlah Kutipan Hasil",
            // numbersuffix: "K",
            numberprefix: "RM",
            theme: "fusion",
        },
        data: [
            {
                label: "Hasil Cukai",
                value: "581845.83","color": "#FF9F45",
            },
            {
                label: "Hasil Bukan Cukai",
                value: "3243168.02","color": "#F76E11",
            },
            {
                label: "Pelbagai Terimaan dan Pindahan",
                value: "330.0","color": "#FFBC80",
            },
        ],
    },
};
</script>
